const config = {
  APP_VERSION: "3.1.22",

  /* Local */
  // GRAPHQL_HTTP: "http://localhost:8100/graphql",

  /* Production */
  GRAPHQL_HTTP: "https://pos-server.wellclean.com.my/graphql",
}

export default config